BatchGeoStore.addReducer(
  "BatchGeoOptimalRouteToolbar",
  {
    toolbarVisible: false,
    modalVisible: false,
    routeCalculated: false,
    currentRows: [],
    previousRows: [],
    uncleanedRows: [],
    selectedRowGroupA: [],
    selectedRowGroupB: [],
    matchNewSelectionToggled: false,
    polylineData: [],
    polylines: [],
    groupDistanceEngaged: false,
    distanceMode: 0,
    distanceChannel: -1,
    distanceCalculationOption: 0,
    optimalRoute: {
      origin: null,
      destination: null,
      /**
       * a waypoint will be stored in state as an
       * object with 2 properties:location, and valid
       *
       * @example
       * waypoints: [
       *      {
       *          location: 'valid example address',
       *          valid: true
       *      },
       *      {
       *          location: 'invalid example address',
       *          valid: false
       *      }
       * ]
       */
      waypoints: [],
      legs: [],
    },
  },
  {
    OPTIMAL_ROUTE_TOOLBAR_SET_ORIGIN: function (state, action) {
      return $.extend(true, {}, state, {
        optimalRoute: {
          origin: action.position,
        },
      });
    },
    OPTIMAL_ROUTE_TOOLBAR_SET_DESTINATION: function (state, action) {
      return $.extend(true, {}, state, {
        optimalRoute: {
          destination: action.position,
        },
      });
    },
    OPTIMAL_ROUTE_TOOLBAR_SET_LEGS: function (state, action) {
      // deep object merge
      return $.extend(true, {}, state, {
        optimalRoute: {
          legs: action.legs,
        },
      });
    },
    OPTIMAL_ROUTE_RESET_ROUTE: function (state, _action) {
      return Object.assign({}, state, {
        optimalRoute: {
          origin: null,
          destination: null,
          waypoints: [],
          legs: [],
        },
        routeCalculated: false,
      });
    },
    OPTIMAL_ROUTE_TOOLBAR_VISIBILITY: function (state, action) {
      return Object.assign({}, state, {
        toolbarVisible: action.isVisible,
      });
    },
    OPTIMAL_ROUTE_MODAL_VISIBILITY: function (state, action) {
      return Object.assign({}, state, {
        modalVisible: action.isVisible,
      });
    },
    OPTIMAL_ROUTE_GROUP_DISTANCE_CHANNEL: function (state, action) {
      return Object.assign({}, state, {
        distanceChannel: action.distanceChannel,
      });
    },
    OPTIMAL_ROUTE_GROUP_DISTANCE_ENGAGED: function (state, action) {
      return Object.assign({}, state, {
        groupDistanceEngaged: action.isEngaged,
      });
    },
    OPTIMAL_ROUTE_GROUP_DISTANCE_MODE: function (state, action) {
      return Object.assign({}, state, {
        distanceMode: action.distanceMode,
      });
    },
    OPTIMAL_ROUTE_GROUP_DISTANCE_CALCULATION_OPTION: function (state, action) {
      return Object.assign({}, state, {
        distanceCalculationOption: action.distanceCalculationOption,
      });
    },
    OPTIMAL_ROUTE_POLYLINE_DATA: function (state, action) {
      return Object.assign({}, state, {
        polylineData: action.polylineData,
      });
    },
    OPTIMAL_ROUTE_REAL_POLYLINES: function (state, action) {
      var currentPolylines = state.polylines;
      var updatePolylines = currentPolylines.concat(action.polylines);
      return Object.assign({}, state, {
        polylines: updatePolylines,
      });
    },
    OPTIMAL_ROUTE_CLEAR_POLYLINES: function (state, _action) {
      return Object.assign({}, state, {
        polylines: [],
        polylineData: [],
      });
    },
    OPTIMAL_ROUTE_GROUP_CURRENT_ROW_UPDATE: function (state, action) {
      return Object.assign({}, state, {
        uncleanedRows: [],
        currentRows: action.currentRows,
      });
    },
    OPTIMAL_ROUTE_GROUP_PREVIOUS_ROW_UPDATE: function (state, action) {
      function getUniqueValues(array1, array2) {
        // Combine the two arrays and remove duplicates
        const combinedArray = [...new Set([...array1, ...array2])];

        // Filter the combined array to get values that are unique to each array
        const uniqueValues = combinedArray.filter((value) => {
          return !array1.includes(value) || !array2.includes(value);
        });

        return uniqueValues;
      }

      function removeValuesAtIndices(indexArray, valueArray) {
        // Sort the index array in descending order
        indexArray.sort((a, b) => b - a);

        // Remove the values at the specified indices from the values array
        indexArray.forEach((index) => {
          valueArray.splice(index, 1);
        });

        return valueArray;
      }

      let previousRows = state?.previousRows;
      let currentRows = state?.currentRows;

      const uniqueValues = getUniqueValues(previousRows, currentRows);
      //remove unqiue values if the unique value itself came from the currentRows array

      let removal = [];

      uniqueValues.forEach((value, index) => {
        if (currentRows.indexOf(value) !== -1) removal.push(index);
      });

      let rowsToCleanUp = removeValuesAtIndices(removal, uniqueValues);

      //finally update state
      return Object.assign({}, state, {
        uncleanedRows:
          rowsToCleanUp && previousRows.length > 0
            ? rowsToCleanUp
            : state.previousRows,
        previousRows: action.previousRows,
      });
    },
    OPTIMAL_ROUTE_TOOLBAR_ADD_WAYPOINT: function (state, action) {
      var oldWaypoints = state.optimalRoute.waypoints;
      var newWaypoints = oldWaypoints.concat([action.waypoint]);
      return $.extend(true, {}, state, {
        optimalRoute: {
          waypoints: newWaypoints,
        },
      });
    },
    OPTIMAL_ROUTE_TOOLBAR_ROUTE_COMPLETE: function (state, _action) {
      return Object.assign({}, state, {
        routeCalculated: true,
      });
    },
    OPTIMAL_ROUTE_TOOLBAR_SET_SELECTION_GROUP: function (state, action) {
      if (action.group === 0) {
        return Object.assign({}, state, {
          selectedRowGroupA: state.currentRows,
        });
      } else {
        return Object.assign({}, state, {
          selectedRowGroupB: state.currentRows,
        });
      }
    },
    OPTIMAL_ROUTE_TOOLBAR_CLEAR_SELECTIONS: function (state) {
      return Object.assign({}, state, {
        selectedRowGroupA: [],
        selectedRowGroupB: [],
        matchNewSelectionToggled: false,
      });
    },
    OPTIMAL_ROUTE_TOOLBAR_TOGGLE_MATCH_NEW_SELECTION: function (state) {
      return Object.assign({}, state, {
        matchNewSelectionToggled: !state.matchNewSelectionToggled,
      });
    },
  },
);
